import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/new/components/shadcn/tooltip';
import { cn } from '@/new/lib/utils';

interface SearchButtonProps {
  showSearchBar: boolean;
  onClick: () => void;
}

export const SearchButton = ({ showSearchBar, onClick }: SearchButtonProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="blue"
          size="iconSm"
          onClick={onClick}
          className={cn(showSearchBar ? 'border-sky-700 bg-sky-100' : '')}
        >
          <Icon className="lucide--search" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{showSearchBar ? 'Close search' : 'Search in document'}</p>
      </TooltipContent>
    </Tooltip>
  );
};
